export enum PayinProviderScope {
  Attempted = 'attempted',
  Assigned = 'assigned',
}
